const NEVER_EXPIRES_YEAR = 4200;

/**
 * Formats an ISO date string to "Expires MM/DD/YYYY" format.
 * Uses the user's local timezone so the displayed date reflects
 * when the reward actually expires for them.
 * E.g., "2024-09-01T03:00:00Z" -> "Expires 08/31/2024" for a user in California (PDT)
 *
 * Returns "Never expires" for dates with year >= 4200, which is used by
 * the backend to represent discounts that don't expire.
 */
export function formatExpirationDate(isoDate: string): string {
  const date = new Date(isoDate);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();

  if (year >= NEVER_EXPIRES_YEAR) {
    return 'Never expires';
  }

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `Expires ${month}/${day}/${year}`;
}
